<script setup lang="ts">
	import {ref,computed} from 'vue';
	
	const progress = ref(0);
	
	defineExpose({makeProgress});
	
	const progressStyle = computed(() => {
			return "width:" + progress.value + "%";
		});
	
	function makeProgress(newProgress: number): void {
		progress.value = newProgress;
		if (progress.value>100) {
			progress.value=100;
		}
		else if (progress.value<0) {
			progress.value=0;
		}
    }
</script>
<template>
	<div class="barArea">
		<div class="shell">
			<div class="bar" :style="progressStyle" >
				<span>{{ progress>=15?progress+'%':'' }}</span>
			</div>
		</div>
	</div>
</template>

<style>
	.barArea {
		height: 20px;
	}

	.shell {
		height: 22px;
		width: 250px;
		border: 1px solid var(--logo-secondary-fg);
		border-radius: 13px;
	}

	.bar {
		background: linear-gradient(to right, var(--hover-on-light), var(--hover-on-dark));
		height: 20px;
		border-radius: 9px;
		-webkit-transition: width 1s ease-in-out;
		-moz-transition: width 1s ease-in-out;
		-o-transition: width 1s ease-in-out;
		transition: width 1s ease-in-out;

		span {
			padding-right: 3px;
			color: var(--fg);
			font-size: var(--font-size-l);
			height: 100%;
			display: flex; 
			justify-content: flex-end; 
			align-items: center; 
			align-content: end;
			/*color: var(--main-fg);*/
		}
	}
</style>
